var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('load-page',{attrs:{"visible":_vm.loading}}),(!_vm.loading)?_c('capture'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }